module.exports = "/_next/static/images/murakami_masanori-4f8ca21d3772df5379fd086399943489.jpeg";